const genericUrl = process.env.REACT_APP_API_URL;

export interface UpdateShopItemBody {
    idAula: string;
    nom: string;
    descr: string;
    cost: number;
    stock: number;
    type: string;
    idGameItem: number | null;
}

export async function PutShopItem(idItem: string, body: UpdateShopItemBody) {
    try {
        const response = await fetch(`${genericUrl}:8061/jutge/shop/admin/item/${idItem}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (response.ok) return { ok: true };
        else {
            const msg = await response.text();
            return { ok: false, msg };
        }
    } catch (e) {
        console.error(e);
        return { ok: false, msg: "Error de conexión" };
    }
}
